import {dataLayerPush} from "JQueryScripts/data-layer-handlers/data-layer-push";
import {obtainPlan} from "JQueryScripts/data-layer-handlers/plan-obtainer";

export const bindClickPurchaseEvents = () => {
    if (window.afterDownloadInfo !== undefined) {
        pushEventPurchase(
            window.afterDownloadInfo.type,
            window.afterDownloadInfo.planType,
            window.afterDownloadInfo.id
        );
    }

    if (window.xsollaPage !== undefined && window.afterDownloadInfo !== undefined) {
        pushEventBeginCheckout(window.afterDownloadInfo.type, window.afterDownloadInfo.planType);
    }
};

const pushEventPurchase = async (type, planType, token) => {
    const item = await obtainPlan(planType, type, 'purchase');
    item['ecommerce']['transaction_id'] = token;

    dataLayerPush(item);
};

const pushEventBeginCheckout = async (type, planType) => {
    const item = await obtainPlan(planType, type, 'begin_checkout');

    dataLayerPush(item);
};